import { render, staticRenderFns } from "./AccreditationsDetails.vue?vue&type=template&id=329daf12&"
import script from "./AccreditationsDetails.vue?vue&type=script&lang=js&"
export * from "./AccreditationsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports